import { DatePipe, NgClass } from '@angular/common';
import {
  Component,
  computed,
  inject,
  input,
  OnDestroy,
  OnInit,
  output,
} from '@angular/core';
import { Subscription } from 'rxjs';

import {
  AppSettingsService,
  PostMessageService,
  SearchService,
} from '../../services/app';

import { SearchDrawerComponent } from '../search-drawer/search-drawer.component';
import { LayoutType } from '../../enums';
import { SelectFlightState } from '../../models/app';
import { LunarDatePipe } from '../../pipes';

@Component({
  selector: 'app-flight-steps',
  templateUrl: './flight-steps.component.html',
  standalone: true,
  imports: [NgClass, DatePipe, SearchDrawerComponent, LunarDatePipe],
})
export class FlightStepsComponent implements OnInit, OnDestroy {
  private _subscriptions$: Subscription[] = [];
  private _postMessageService = inject(PostMessageService);
  private _searchService = inject(SearchService);
  readonly appSettings = inject(AppSettingsService).state;
  readonly step = input(1);
  readonly isLoading = input(false);
  readonly itineraryInformation = input<SelectFlightState>();
  readonly itinerary = computed(() => {
    if (!this.itineraryInformation()) {
      return undefined;
    }

    const {
      roundTrip,
      showSmartCombo,
      selectedFlight,
      from,
      to,
      date,
      returnDate,
    } = this.itineraryInformation()!;

    if (roundTrip && selectedFlight) {
      return {
        from: to,
        to: from,
        date: returnDate,
        returnDate: null,
      };
    }

    return {
      from,
      to,
      date,
      returnDate: null,
    };
  });
  readonly showCompactButton = input(false);
  readonly showCompact = input(false);
  readonly showCompactChange = output<void>();
  readonly showCheapPricesButton = input(false);
  readonly showCheapPrices = output<void>();
  readonly showDownloadPriceButton = input(false);
  readonly showDownloadPrice = output<void>();
  readonly showSmartComboButton = input(false);
  readonly showSmartCombo = input(false);
  readonly showSmartComboChange = output<void>();
  readonly LayoutType = LayoutType;
  readonly title = computed(() => {
    let value = '';
    switch (this.step()) {
      case 1:
        value = 'Tìm chuyến bay';
        break;
      case 2:
        value = 'Thông tin hành khách';
        break;
      case 3:
        value = 'Chọn dịch vụ';
        break;
      case 4:
        value = 'Thanh toán';
        break;
    }
    return value;
  });

  ngOnInit(): void {
    this._subscriptions$.push(
      this._searchService.navigate$.subscribe(() => {
        if (this.step() === 1) {
          this._searchService.search();
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this._subscriptions$.forEach((s) => s?.unsubscribe());
  }

  onShowCheapPrices() {
    this.showCheapPrices.emit();
    this._postMessageService.postMessageScrollIntoView();
  }

  onShowDownloadPrice() {
    this.showDownloadPrice.emit();
    this._postMessageService.postMessageScrollIntoView();
  }

  onToggleSmartCombo() {
    this.showSmartComboChange.emit();
    this._postMessageService.postMessageScrollIntoView();
  }
}
